function EmptyStateTabelFile({ colSpan = 1 }) {
  return (
    <>
      <tr className="empty-row">
        <td colSpan={colSpan} className="text-center p-3">
          <div className="text-gray-300 mb-2">
            <i className="fa fa-file-archive fa-3x"></i>
          </div>
          No file uploaded
        </td>
      </tr>
    </>
  );
}

export default EmptyStateTabelFile;
